import {
  KeyboardArrowDown,
  KeyboardArrowUp,
  OpenInNew,
} from "@mui/icons-material";
import {
  Collapse,
  // List,
  // ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Tooltip,
  Typography,
  useTheme,
} from "@mui/material";
import React from "react";
import { useHistory, useLocation } from "react-router-dom";
import { usePermissions } from "src/grading/hooks/usePermissions";
import { useAppDispatch, useAppSelector } from "src/store/hooks";
import {
  selectDropdownOpen,
  selectShowDrawer,
  setDropdownOpen,
} from "src/store/reducers/navigation/navigationSlice";
import useStyles from "./NavigationLink.styles";
import { NavLink } from "./links";

interface NavigationLinkProps {
  link: NavLink;
}

const NavigationLink = ({ link }: NavigationLinkProps) => {
  const theme = useTheme();
  const location = useLocation();
  const showDrawer = useAppSelector(selectShowDrawer);
  const classes = useStyles(showDrawer)();
  const history = useHistory();
  const { hasPermissions } = usePermissions();
  const { permission, childLinks, ...rest } = link;
  const dispatch = useAppDispatch();
  const dropdownOpen = useAppSelector(selectDropdownOpen);

  if (permission && !hasPermissions(permission.action, permission.subject)) {
    return <></>;
  }

  const handleLinkClick = (link: NavLink) => {
    if (link.childLinks) {
      dispatch(setDropdownOpen(link.name === dropdownOpen ? "" : link.name));
      return;
    }
    if (link.onClick) {
      link.onClick();
    } else {
      history.push(link.path);
      if (link.parent !== dropdownOpen) {
        dispatch(setDropdownOpen(link.parent || ""));
      }
    }
  };

  const dropdownArrow = () =>
    dropdownOpen === link.name ? <KeyboardArrowUp /> : <KeyboardArrowDown />;

  const linkName = link.name?.toUpperCase();

  return (
    <>
      <Tooltip title={linkName}>
        <ListItemButton
          {...rest}
          className={`${classes.link} ${classes.topLink} ${
            link.path &&
            location.pathname.includes(link.path) &&
            classes.selectedLink
          }`}
          onClick={() => handleLinkClick(link)}
          style={
            !showDrawer ? { justifyContent: "center", padding: "12px" } : {}
          }
        >
          <ListItemIcon className={classes.listIcon}>{link.icon}</ListItemIcon>
          <ListItemText
            primary={<Typography variant="button">{linkName}</Typography>}
            sx={{
              color: theme.palette.primary.contrastText,
            }}
            style={!showDrawer ? { display: "none" } : {}}
          />
          {showDrawer && link.childLinks && (
            <ListItemIcon className={classes.arrowIcon}>
              {link.childLinks && showDrawer ? dropdownArrow() : null}
              {link.openInNewTab && <OpenInNew />}
            </ListItemIcon>
          )}
        </ListItemButton>
      </Tooltip>

      {link.childLinks && showDrawer && (
        <Collapse
          in={link.name === dropdownOpen}
          timeout={"auto"}
          unmountOnExit
          sx={{
            // borderLeft: "1px solid #333",
            // paddingLeft: theme.spacing(2),
            "& .MuiCollapse-wrapperInner": {
              display: "flex",
              flexDirection: " column",
              paddingLeft: theme.spacing(3),
              borderLeft: "1px solid #333",
              marginLeft: theme.spacing(3),
            },
          }}
        >
          {link.childLinks.map((childLink: NavLink, i: number) => {
            const childLinkName = childLink.name?.toUpperCase();
            return (
              <ListItemButton
                key={`${childLinkName}-${i}`}
                {...rest}
                className={`${classes.link} ${classes.topLink} ${
                  childLink.path &&
                  location.pathname.includes(childLink.path) &&
                  classes.selectedLink
                }`}
                onClick={() => handleLinkClick(childLink)}
                style={!showDrawer ? { width: "fit-content" } : {}}
              >
                {childLink.icon && (
                  <ListItemIcon
                    style={!showDrawer ? { width: "fit-content" } : {}}
                    classes={!showDrawer ? { root: classes.listIconWidth } : {}}
                  >
                    {childLink.icon}
                  </ListItemIcon>
                )}

                <ListItemText
                  primary={
                    <Typography variant="subtitle1" color={"#fff"}>
                      {childLinkName}
                    </Typography>
                  }
                  style={!showDrawer ? { display: "none" } : {}}
                />
              </ListItemButton>
            );
          })}
        </Collapse>
      )}
    </>
  );
};

export default NavigationLink;
